import { jsxs as c, jsx as s } from "react/jsx-runtime";
import { useState as f, useRef as l } from "react";
import p from "./useOutsideClick.js";
import { tv as b } from "tailwind-variants";
import v from "./Burger.js";
import w from "./Item.js";
import x from "./Nav.js";
const h = b({
  slots: {
    wrapper: ["flex tablet:relative"],
    icon: ["text-neutral-900", "transition-transform"],
    dropdown: [
      "absolute",
      "bg-white",
      "border-b",
      "border-t",
      "border-neutral-200",
      "flex",
      "flex-col",
      "right-0",
      "top-full",
      "w-full",
      "z-10",
      "tablet:border",
      "tablet:rounded-lg",
      "tablet:shadow-md",
      "tablet:top-[calc(100%+1rem)]",
      "tablet:w-auto"
    ]
  },
  variants: {
    isActive: {
      true: {
        icon: ["rotate-180"]
      }
    }
  }
}), { wrapper: g, dropdown: C } = h(), r = ({ button: n, children: i, className: d, dropdownClassName: m }) => {
  const [e, t] = f(!1), o = l(), a = l();
  return p(o, a, () => t(!1)), /* @__PURE__ */ c("div", { className: g({ class: d }), children: [
    /* @__PURE__ */ s(
      n,
      {
        "aria-controls": "header-menu",
        "aria-expanded": e,
        "aria-haspopup": "menu",
        isActive: e,
        onClick: () => t(!e),
        ref: o
      }
    ),
    e && /* @__PURE__ */ s(
      "div",
      {
        className: C({ class: m }),
        id: "header-menu",
        onClick: (u) => {
          !u.target.dataset.noCloseMenu && t(!1);
        },
        ref: a,
        children: i
      }
    )
  ] });
};
r.Burger = v;
r.Item = w;
r.Nav = x;
export {
  r as default
};
